'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdFilterVintage = function MdFilterVintage(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 26.6c3.7 0 6.6-2.9 6.6-6.6s-2.9-6.6-6.6-6.6-6.6 2.9-6.6 6.6 2.9 6.6 6.6 6.6z m-16.2 2.7c0-3.8 2.5-8 6.4-9.3-0.4-0.2-0.9-0.5-1.4-0.7-3.2-1.9-5-5.2-5-8.6 3-1.7 6.8-1.9 10 0 0.5 0.2 1 0.6 1.4 0.9-0.1-0.6-0.2-1.1-0.2-1.6 0-3.7 2-7 5-8.7 3 1.7 5 5 5 8.7 0 0.5-0.1 1-0.2 1.6 0.4-0.3 0.9-0.7 1.4-0.9 3.2-1.9 7-1.7 10 0 0 3.4-1.8 6.7-5 8.6-0.5 0.2-1 0.5-1.4 0.7 0.4 0.2 0.9 0.5 1.4 0.7 3.2 1.9 5 5.2 5 8.6-3 1.7-6.8 1.9-10 0-0.5-0.2-1-0.5-1.4-0.9 0.1 0.6 0.2 1.1 0.2 1.6 0 3.7-2 7-5 8.7-3-1.7-5-5-5-8.7 0-0.5 0.1-1 0.2-1.6-0.4 0.4-0.9 0.7-1.4 0.9-3.2 1.9-7 1.7-10 0z' })
        )
    );
};

exports.default = MdFilterVintage;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/filter-vintage.js
// module id = 2879
// module chunks = 0